import { render, staticRenderFns } from "./BaseRelation.vue?vue&type=template&id=b2628ba2&"
import script from "./BaseRelation.vue?vue&type=script&lang=ts&"
export * from "./BaseRelation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports